/** @format */

import { Routes, Route } from "react-router";
import PublicLayout from "./PublicLayout";
import PublicRoutes from "../utils/routes/public";

const DefaultLayout = () => {
  //Routes
  const showPublicMenu = (routes: any) => {
    var result = null;
    if (routes.length > 0) {
      result = routes.map((route: any, index: number) => {
        return (
          <Route key={index} path={route.path} element={route.main()}>
            {route.children && showPublicMenu(route.children)}
          </Route>
        );
      });
    }
    return result;
  };

  return (
    <Routes>
      <Route element={<PublicLayout />}>{showPublicMenu(PublicRoutes)}</Route>
    </Routes>
  );
};

export default DefaultLayout;
